// eslint-disable-next-line max-len
import { PrintFormController } from '../../controllers/print-form-controller.class'
import utils, { firstDayOfMonth, lastDayOfMonth } from '../../utils'

/** @ngInject */
class Otper2FormController extends PrintFormController {
  reportName = 'oper2'

  get defaultFilters() {
    return {
      from: firstDayOfMonth(),
      to: lastDayOfMonth(),
      excludeInnerRashod: false,
      firm: null,
    }
  }

  get convertedFilters() {
    return {
      d1: utils.db.date2dmy(this.filters.from),
      d2: utils.db.date2dmy(this.filters.to),
      firm: this.filters.firm,
      vn: this.filters.excludeInnerRashod ? '1' : '',
    }
  }
}

export const Otper2FormComponent = {
  template: require('./otper2-form.component.html'),
  styles: [require('./otper2-form.component.scss')],
  bindings: {},
  controller: Otper2FormController,
}
